export default {
  SUBSCRIPTION_URL: 'wss://api.thegraph.com/subgraphs/name/aave/protocol-v2',
  URL: 'https://api.thegraph.com/subgraphs/name/aave/protocol-v2',
  POOL_ID: '0xb53c1a33016b2dc2ff3653530bff1848a515c8c5'
};
